import { z } from 'zod'

export const templateDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullable().optional(),
  category: z.string().nullable().optional(),
  isPublic: z.boolean(),
  tenantId: z.string().nullable().optional(),
  tags: z.array(z.string()).nullable().optional(),
  version: z.number().optional(),
  definition: z.unknown().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type TemplateDto = z.infer<typeof templateDtoSchema>

export const pagedTemplateDataSchema = z.object({
  items: z.array(templateDtoSchema),
  totalCount: z.number(),
  page: z.number(),
  pageSize: z.number(),
  totalPages: z.number(),
})

export const pagedTemplateResponseSchema = z.object({
  success: z.boolean(),
  data: pagedTemplateDataSchema,
})
